import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';

export default buildFacetDesignOverride()
  .typeOverride('picklist', {
    _customProps: {
      fullWidth: true,
    },
  });
